import { Box } from '@chakra-ui/react';

import { Condition, Iteration } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import { useBriefLiveState } from 'View/brief-live/state';

import styles from './styles.module.css';

const PrizesColumn = ({ value, values }) => {
  const { updateState } = useBriefLiveState();
  return (
    <Box className={styles['prizes-column__container']}>
      <Condition
        statement={value && value?.length > 0}
        fallback={
          <Box className={styles['prizes-column__box--item']}>
            <TextRegular className={styles['prizes-column__text']}>-</TextRegular>
          </Box>
        }
      >
        <Iteration
          items={value?.filter((_, index) => index < 3)}
          render={(prize, index) => {
            const isHasMore = value?.length > 3 && index === 2;
            return (
              <Box className={styles['prizes-column__box--item']}>
                <TextRegular className={styles['prizes-column__text']}>{prize.productName}</TextRegular>
                <Condition statement={isHasMore}>
                  <TextSemiBold
                    className={styles['prizes-column__text--more']}
                    onClick={() => {
                      updateState({
                        isOpenModalPrizeList: true,
                        prizeListData: values,
                      });
                    }}
                  >
                    + {value?.length - 3} lainnya
                  </TextSemiBold>
                </Condition>
              </Box>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default PrizesColumn;
